module.exports = __webpack_public_path__ + "static/media/homeBgImg.6b9d9a98.png";